import React, { useEffect, useState } from "react";
import { ProjectAmenities, ProjectAmenity } from "../../../interfaces/projects";
import { transformCloudinaryImg } from "../../../services/utils";
import Carousel from "../Carousel";
import Icon from "../Icon";
import { ScaledText } from "../ScaledText";
import VideoLazy from "../Video";
import "./projectsAmenities.scss";

const ProjectsAmenities: React.FC<ProjectAmenities> = ({
  colors,
  title,
  amenities,
}) => {
  const [amenitiesProccess, setAmenitiesProcess] = useState<ProjectAmenity[]>(
    []
  );
  const [opacity, setOpacity] = useState<any>({});
  const [hideOverlay, setHideOverlay] = useState<boolean>(false);
  const [activeIndex, setActiveIndex] = useState<number>(0);

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const { clientWidth } = document.documentElement;

      setAmenitiesProcess(
        amenities.map((amenity: ProjectAmenity) => ({
          ...amenity,
          image: transformCloudinaryImg(
            amenity.image,
            clientWidth <= 768 ? "f_auto,q_70,h_400" : "f_auto,q_70,w_1920"
          ),
        }))
      );
    }
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (typeof window !== `undefined`) {
        const el = document.getElementById("amenities");
        const width = document.documentElement.clientWidth;
        const vh40 = document.documentElement.clientHeight * 0.25;

        if (
          window.pageYOffset - el.offsetTop - (width <= 768 ? 25 : 100) >=
          0
        ) {
          setHideOverlay(true);
        }

        if (window.pageYOffset - el.offsetTop + vh40 >= 0) {
          const movibleWrap = document.getElementById("movible-wrap-amenities");
          const movibleEl = document.getElementById("movible-amenities");
          const opacity =
            ((((movibleEl.offsetTop + movibleEl.clientHeight) * 100) /
              movibleWrap.clientHeight -
              100) *
              -1) /
            100;
          const grayscale =
            (((movibleEl.offsetTop +
              movibleEl.clientHeight -
              document.documentElement.clientHeight * 0.045) *
              100) /
              movibleWrap.clientHeight -
              100 * -1) /
              100 -
            1;
          setOpacity({
            opacity,
            filter: `grayscale(${grayscale > 0.25 ? grayscale : 0})`,
          });
        } else {
          setOpacity({ opacity: 1, filter: `grayscale(${0})` });
        }
      }
    };
    if (typeof window !== `undefined`) {
      window.addEventListener("scroll", onScroll);
    }
    return () => {
      if (typeof window !== `undefined`) {
        return window.removeEventListener("scroll", onScroll);
      }
    };
  }, []);

  return (
    <section className="amenities" id="amenities">
      <div className="container">
        <div className="movible-wrap" id="movible-wrap-amenities">
          <div className="movible" style={opacity} id="movible-amenities">
            <ScaledText text="AMENITIES" />
          </div>
        </div>
      </div>

      <div className="amenities-container">
        <div
          className={`overlay ${hideOverlay ? "hide-overlay" : ""}`}
          style={{ backgroundColor: colors.primary }}
        >
          <h3
            className="montserrat-light"
            style={{ color: colors.contrast }}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        </div>

        <div className="container">
          {/* <h3 className="text-uppercase font-black">AMENITIES</h3> */}
          <div className="icon-list">
            {amenitiesProccess.map((amenity: ProjectAmenity, i: number) => {
              return (
                <div
                  className={`icon-data ${activeIndex === i ? "selected" : ""}`}
                  style={{ color: colors.primary }}
                  key={i}
                  onClick={() => setActiveIndex(i)}
                >
                  <div className="icon">
                    <Icon name={amenity.icon} />
                  </div>
                  <p
                    className="text-uppercase font-bold"
                    dangerouslySetInnerHTML={{
                      __html: amenity.title,
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>

        <div className="amenities-carousel">
          <Carousel
            autoPlay={false}
            renderDots={({ setActiveIndex, activeIndex }) => (
              <div className="carousel-dots">
                {new Array(amenities.length).fill("").map((_, i) => (
                  <span
                    onClick={() => setActiveIndex(i)}
                    key={i}
                    style={{
                      background: i === activeIndex ? colors.primary : "#fff",
                      opacity: i === activeIndex ? 1 : 0.75,
                    }}
                  ></span>
                ))}
              </div>
            )}
            renderArrowRight={({ handleNext }) => (
              <div className="arrow-control arrow-right" onClick={handleNext}>
                <Icon name="chevron-right" color="#fff" />
              </div>
            )}
            renderArrowLeft={({ handlePrev }) => (
              <div className="arrow-control arrow-left" onClick={handlePrev}>
                <Icon name="chevron-left" color="#fff" />
              </div>
            )}
            onSlideChange={(index) => setActiveIndex(index)}
            interval={5000}
            activeIndex={activeIndex}
            loop={true}
          >
            {amenitiesProccess.map((amenity: ProjectAmenity, i: number) => {
              return (
                <>
                  {amenity.video ? (
                    <VideoLazy
                      poster={amenity.video.poster}
                      url={amenity.video.url}
                    />
                  ) : (
                    <img
                      key={i}
                      className={`carousel-item object-${
                        amenity.objectPosition ?? "center"
                      }`}
                      src={amenity.image}
                      alt={amenity.title}
                      loading="lazy"
                    />
                  )}
                </>
              );
            })}
          </Carousel>
        </div>

        <div className="container">
          {amenitiesProccess.map((amenity: ProjectAmenity, i: number) => {
            return (
              <React.Fragment key={i}>
                {i === activeIndex && amenity.description && (
                  <div className="amenity-info">
                    <div>
                      <h3
                        className="font-book"
                        dangerouslySetInnerHTML={{
                          __html: amenity.title,
                        }}
                      />
                      {amenity.subtitle && (
                        <h4
                          dangerouslySetInnerHTML={{
                            __html: amenity.subtitle,
                          }}
                        />
                      )}
                    </div>
                    <div className="separator" />
                    <div>
                      <p
                        className="font-book"
                        dangerouslySetInnerHTML={{
                          __html: amenity.description,
                        }}
                      />
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProjectsAmenities;
